// extracted by mini-css-extract-plugin
export default {"ripple":"d06d9b","ripple--animate":"dc26b8"};